import firebase from 'firebase/app'
import { Switch, Route } from 'react-router-dom'
import GameList from './GameList'
import GamePreparationScreen from './GamePreparationScreen'
import { GameResumeScreen } from './GameResumeScreen'
import ComponentsDemo from '@/components/ComponentsDemo'
import BackgroundStars from '@/components/BackgroundStars'

const provider = new firebase.auth.GoogleAuthProvider()
if (window.location.host.indexOf('localhost') !== -1) {
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
}

export default () => {
  return (
    <>
      <BackgroundStars />
      <Switch>
        <Route path="/games/components" component={ComponentsDemo} />
        <Route path="/games/resume/:id?" component={GameResumeScreen} />
        <Route path="/games/:id" component={GamePreparationScreen} />
        <Route path="/games" component={GameList} />
      </Switch>
    </>
  )
}
